import reportsProgressMilestone from './reportsProgressMilestone';
import list from './list';
import project from './project';
import multiview from './multiview';
import sharedGantt from './sharedGantt';
import sharedBoard from './sharedBoard';
import userLogs from './userLogs';
import reportsTimeTimeloglist from './timeloglist';
import costslist from './costslist';
import calendarview from './calendarview';
import boardview from './boardview';
import history from './history';
import workload from './workload';
import reportsProgressStatuses from './reportsProgressStatuses';
import reportsProgressSchedule from './reportsProgressSchedule';
import reportsProgressPortfolio from './reportsProgressPortfolio';
import reportsProgressMonth from './reportsProgressMonth';
import reportsBudgetProject from './reportsBudgetProject';
import reportsBudgetMonth from './reportsBudgetMonth';
import reportsTimeMonth from './reportsTimeMonth';
import reportsTimeProject from './reportsTimeProject';
import reportsBudgetResource from './reportsBudgetResource';
import reportsTimeResource from './reportsTimeResource';

export default {
  list,
  reportsProgressMilestone,
  project,
  multiview,
  sharedGantt,
  sharedBoard,
  userLogs,
  reportsTimeTimeloglist,
  costslist,
  calendarview,
  boardview,
  history,
  workload,
  reportsProgressStatuses,
  reportsProgressSchedule,
  reportsProgressPortfolio,
  reportsProgressMonth,
  reportsBudgetProject,
  reportsBudgetMonth,
  reportsTimeMonth,
  reportsTimeProject,
  reportsBudgetResource,
  reportsTimeResource,
};
